// extracted by mini-css-extract-plugin
module.exports = {"btn":"Button_btn__2lKhf","fullWidth":"Button_fullWidth__37cJg"};